import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from './auth/auth.guard';
import { PortalAuthGuard } from './portal/portal-auth.guard';
import { LoginComponent } from './auth/login.component';

const routes: Routes = [
    {
        path: 'App/DxRoot',
        loadChildren: './dxroot/dxroot.module#DxRootModule',
        canActivate: [AuthGuard]        
    },
    {
        path: 'App/DTS',
        loadChildren: './dts/dts.module#DtsModule'
    },
    {
        path: 'App/ClientPortal',
        loadChildren: './client-portal/client-portal.module#ClientPortalModule',
        canActivate: [AuthGuard]
    },        
    {
        path: 'App/Claim',
        loadChildren: './claim/claim.module#ClaimModule',
        canActivate: [AuthGuard]
    },
    {
        path: 'App/Collection',
        loadChildren: './collection/collection.module#CollectionModule',
        canActivate: [AuthGuard]
    },
    {
        path: 'App/Client',
        loadChildren: './client/client.module#ClientModule',
        canActivate: [AuthGuard]
    },
    {
        path: 'App/Offer',
        loadChildren: './offer/offer.module#OfferModule',
        canActivate: [AuthGuard]
    },
    {
        path: 'App/Policy',
        loadChildren: './policy/policy.module#PolicyModule',
        canActivate: [AuthGuard]
    },
    {
        path: 'App/Report',
        loadChildren: './report/report.module#ReportModule',
        canActivate: [AuthGuard]
    },
    {
        path: 'App/Discount',
        loadChildren: './discount/discount.module#DiscountModule',
        canActivate: [AuthGuard]
    },
    {
        path: 'App/Promotion',
        loadChildren: './promotion/promotion.module#PromotionModule',
        canActivate: [AuthGuard]
    },
    {
        path: 'App/Template/Claim',
        loadChildren: './template/claim/template-claim.module#TemplateClaimModule',
        canActivate: [AuthGuard]
    },
    {
        path: 'App/Template/Client',
        loadChildren: './template/client/template-client.module#TemplateClientModule',
        canActivate: [AuthGuard]
    },
    {
        path: 'App/Template/Offer',
        loadChildren: './template/offer/template-offer.module#TemplateOfferModule',
        canActivate: [AuthGuard]
    },
    {
        path: 'App/Template/Policy',
        loadChildren: './template/policy/template-policy.module#TemplatePolicyModule',
        canActivate: [AuthGuard]
    },
    {
        path: 'App/Template/Report',
        loadChildren: './template/report/template-report.module#TemplateReportModule',
        canActivate: [AuthGuard]
    },
    {
        path: 'App/Notification',
        loadChildren: './notification/notification.module#NotificationModule',
        canActivate: [AuthGuard]
    },
    {
        path: 'App/Profile',
        loadChildren: './profile/profile.module#ProfileModule',
        canActivate: [AuthGuard]
    },    
    {
        path: 'Portal/Home',
        loadChildren: './portal/portal.module#PortalModule',
        canActivate: [PortalAuthGuard]
    },
    { path: 'Account/Login', component: LoginComponent },
    { path: '', loadChildren: './dxroot/dxroot.module#DxRootModule', canActivate: [AuthGuard] },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
